import { useCallback } from "react"


const createQueryString = (name, value, searchParams) => {
  const newParams = {}
  Object.keys(searchParams).forEach(key => {
    newParams[key] = searchParams[key]
  })
  newParams[name] = value
  newParams['page'] = 1
  if (value === 'null') delete newParams[name]
  const queryString = new URLSearchParams(newParams).toString()
  return queryString
}


export { createQueryString }